import { apiSlice } from "../../api/apiSlice";

export const urlRedirectApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUrlRedirects: builder.query({
      query: ({ limit, page, search }) => {
        const params = new URLSearchParams({
          page: String(page),
          limit: String(limit),
          search: search || "",
        });
        return `/api/v1/admin/redirects/listing?${params.toString()}`;
      },
      providesTags: ["UrlRedirect"],
    }),
    getUrlRedirectById: builder.query({
      query: (id) => `/api/v1/admin/redirects/${id}`,
      providesTags: (result, error, id) => [{ type: "UrlRedirect", id }],
    }),
    createUrlRedirect: builder.mutation({
      query: (data) => ({
        url: "/api/v1/admin/redirects",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["UrlRedirect"],
    }),
    updateUrlRedirect: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api/v1/admin/redirects/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["UrlRedirect"],
    }),
    deleteUrlRedirect: builder.mutation({
      query: (id) => ({
        url: `/api/v1/admin/redirects/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["UrlRedirect"],
    }),
  }),
});

export const {
  useGetUrlRedirectsQuery,
  useGetUrlRedirectByIdQuery,
  useCreateUrlRedirectMutation,
  useUpdateUrlRedirectMutation,
  useDeleteUrlRedirectMutation,
} = urlRedirectApiSlice;
